import {
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSimpleInputOutlined,
    RaikoToggleOutlined,
    convertPersianDateToUniversalDate,
    showSuccessMessage, showServerErrorMessage, RaikoSectionContainer, RaikoDatePicker
} from "@moeindal/base-raiko-panel-components";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useState} from "react";
import {css} from "@emotion/css";


export default function AddNewPeriod() {

    const service = new PeriodService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [periodName, setPeriodName] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [numberOffDaysAllowed, setNumberOffDaysAllowed] = useState("")

    const [acceptation, setAcceptation] = useState(false);
    const [automaticAcceptance, setAutomaticAcceptance] = useState(false);


    function handleAddNewPeriod() {
        loading.show()
        service.createNewPeriod(
            periodName,
            numberOffDaysAllowed,
            convertPersianDateToUniversalDate(startDate),
            convertPersianDateToUniversalDate(endDate),
            acceptation,
            automaticAcceptance,
        ).then(response => {
            showSuccessMessage("بازه ی زمانی جدید با موفقیت افزوده شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoSectionContainer
                title={"افزودن دوره زمانی"}
                hasActionButton
                actionButtonOnclickWithValidation={handleAddNewPeriod}
                actionButtonTitle={"افزودن"}
            >
                <RaikoGridOneColumn className={css`width: 100%`}>
                    <RaikoSimpleInputOutlined
                        labelText={"نام دوره زمانی"}
                        setValue={setPeriodName}
                        value={periodName}
                        required
                    />
                    <RaikoDatePicker
                        label={"تاریخ شروع"}
                        date={startDate}
                        setDate={setStartDate}
                        required
                    />
                    <RaikoDatePicker
                        label={"تاریخ پایان"}
                        date={endDate}
                        setDate={setEndDate}
                        required
                    />
                    <RaikoSimpleInputOutlined
                        labelText={"حداکثر روز اقامت"}
                        setValue={setNumberOffDaysAllowed}
                        value={numberOffDaysAllowed}
                        required
                    />
                    <RaikoToggleOutlined
                        labelText={"پذیرش اسکان"}
                        setChecked={setAcceptation}
                        checked={acceptation}
                    />
                    <RaikoToggleOutlined
                        labelText={"اسکان دهی خودکار"}
                        setChecked={setAutomaticAcceptance}
                        checked={automaticAcceptance}/>
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoGridOneColumn>

    )
}